import Vue from 'vue';
import Vuex from 'vuex';
import Axios from 'axios';
import bot from './modules/bot';
import companies from './modules/companies';

Vue.use(Vuex);

if (process.env.VUE_APP_API_URL) {
  Axios.defaults.baseURL = process.env.VUE_APP_API_URL;
}
Axios.defaults.route = process.env.VUE_APP_API_ROUTE;
Axios.defaults.withCredentials = true;

export default new Vuex.Store({
  state: {
    authenticated: false,
    showAuthPopup: false,
    user: {}
  },
  mutations: {
    UPDATE_AUTH_STATUS(state, status) {
      state.authenticated = status;
    },
    UPDATE_AUTH_POPUP_STATUS(state, status) {
      state.showAuthPopup = status;
    },
    UPDATE_USER(state, status) {
      state.user = status;
    }
  },
  actions: {
    setAuthStatus(ctx, value) {
      ctx.commit('UPDATE_AUTH_STATUS', value);
    },
    setAuthPopupStatus(ctx, value) {
      ctx.commit('UPDATE_AUTH_POPUP_STATUS', value);
    },
    async getUserData(ctx) {
      try {
        const result = await Axios.get(Axios.defaults.route + '/user');
        if (result.status === 200 && result.data.id) {
          ctx.commit('UPDATE_AUTH_POPUP_STATUS', false);
          ctx.commit('UPDATE_USER', result.data);
          return true;
        } else {
          return false;
        }
      } catch (error) {
        console.error(error);
        return false;
      }
    }
  },
  getters: {
    getAuthStatus(state) {
      return state.authenticated;
    },
    getAuthPopupStatus(state) {
      return state.showAuthPopup;
    },
    getUser(state) {
      return state.user;
    }
  },
  modules: { bot, companies }
})
